import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BaseMessage from './BaseMessage';
import { cliAnalyticsError, cliAnalyticsRequestApproval, cliAnalyticsRequestDecline, cliAnalyticsRequestPartialApproval } from '../../../../const/analytics';
import { ConfigContext } from '../../context';
import i18n from '../../strings/i18n';
export const Success = ({ newCreditLimit, image }) => {
    const { triggerAnalyticsEvent } = useContext(ConfigContext);
    const { t: translate } = useTranslation(undefined, { i18n });
    useEffect(() => {
        triggerAnalyticsEvent(cliAnalyticsRequestApproval);
    });
    return (_jsx(BaseMessage, { ...{
            id: 'cli-full-approval',
            newCreditLimit,
            image,
            title: translate('cliSuccess.title'),
            subTitle: translate('cliSuccess.subTitle'),
            subText: translate('cliSuccess.subText')
        } }));
};
export const PartialSuccess = ({ newCreditLimit, image }) => {
    const { triggerAnalyticsEvent } = useContext(ConfigContext);
    const { t: translate } = useTranslation(undefined, { i18n });
    useEffect(() => {
        triggerAnalyticsEvent(cliAnalyticsRequestPartialApproval);
    });
    return (_jsx(BaseMessage, { ...{
            id: 'cli-partial-success',
            newCreditLimit,
            image,
            title: translate('cliSuccess.title'),
            subTitle: translate('cliPartialSuccess.subTitle'),
            subText: translate('cliSuccess.subText')
        } }));
};
export const ErrorMessage = ({ id, image }) => {
    const { triggerAnalyticsEvent } = useContext(ConfigContext);
    const { t: translate } = useTranslation(undefined, { i18n });
    useEffect(() => {
        triggerAnalyticsEvent(cliAnalyticsError);
    });
    return (_jsx(BaseMessage, { ...{
            id,
            image,
            subTitle: translate('errorMessages.unableToProcessRequest')
        } }));
};
export const BusinessErrorMessage = ({ creditLimit, errorMessage }) => {
    const { triggerAnalyticsEvent } = useContext(ConfigContext);
    const { t: translate } = useTranslation(undefined, { i18n });
    useEffect(() => {
        triggerAnalyticsEvent({
            ...cliAnalyticsRequestDecline,
            message: errorMessage
        });
    });
    return (_jsx(BaseMessage, { ...{
            id: 'cli-business-error',
            title: translate('cliBusinessError.title'),
            subTitle: translate('cliBusinessError.subTitle'),
            currentCreditLimit: creditLimit
        } }));
};
export const PendingReferral = ({ creditLimit, errorMessage }) => {
    const { triggerAnalyticsEvent } = useContext(ConfigContext);
    const { t: translate } = useTranslation(undefined, { i18n });
    useEffect(() => {
        triggerAnalyticsEvent({
            ...cliAnalyticsRequestDecline,
            message: errorMessage
        });
    });
    return (_jsx(BaseMessage, { ...{
            id: 'cli-pending-referral',
            title: translate('cliPendingReferral.title'),
            subTitle: translate('cliPendingReferral.subTitle'),
            currentCreditLimit: creditLimit
        } }));
};
